var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9615 12.144C21.8832 12.048 21.7874 12 21.6743 12C21.5611 12 21.4654 12.048 21.3871 12.144L14.9766 20L21.3871 27.856C21.4654 27.952 21.5611 28 21.6743 28C21.7874 28 21.8832 27.952 21.9615 27.856C22.0399 27.76 22.079 27.6427 22.079 27.504C22.079 27.3653 22.0399 27.248 21.9615 27.152L16.1255 20L21.9615 12.848C22.0399 12.752 22.079 12.6347 22.079 12.496C22.079 12.3573 22.0399 12.24 21.9615 12.144Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPrevious);
export default __webpack_public_path__ + "static/media/button-previous.1da280d6d7f3817e3db873117d9fcc4c.svg";
export { ForwardRef as ReactComponent };